<div class="card card-primary card-outline style">
    <div class="card-body box-profile">
      
     
   <p class="style1">
        <b>{{OrderNumber}}</b>
      </p>
      <div class="table-responsive">
  
        <div *ngFor="let c of output">
        <table class="table style">
        <tbody>
        <tr>
        <th style="width:25%">Created Date And Time:</th>
        <td>{{c.createdAt | date : 'short'}}</td>
        </tr>
  
        <tr>
        <th>Total Amount:</th>
        <td>{{c.total_amount}}</td>
        </tr>

        <tr>
        <th>Status:</th>
        <td>{{c.status}}</td>
        </tr>
       
        <tr>
        <th>Customer Name:</th>
        <td>{{c.customer.customer_name}}</td>
        </tr>
        
        <tr>
        <th>Customer Id:</th>
        <td>{{c.customer_id}}</td>
        </tr>
  
        <tr>
        <th>Contract:</th>
        <td>{{c.contract}}</td>
        </tr>
  

        </tbody></table>
  
        <p class="style2">
          <b>Inventory and Services:</b>
           <div class="card">
            <div class="space" *ngFor="let d of c.products">
           
              <strong class="distance1">Item Name:</strong>{{d.product_name}}<br>
              <!-- <strong class="distance2">Quantity:</strong>{{d.quantity}}<br> -->
              <strong class="distance1">UOM:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>{{d.uom_name}}<br>
              <!-- <strong class="distance4">Amount:</strong>{{d.amount}}<br>
              <strong class="distance5">Vat Amount:</strong>{{d.vat_amount}}<br> -->
              <strong class="distance6">Amount: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>{{d.total_amount}}
              <hr>
  
          
 